import React from 'react';

import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import messages from '../../messages';

import style from './item-stock.module.less';

export const TotalStockLevel = ({ quantity }) => {
  return (
    <div className={style['stock-level-container']}>
      <Text className={style['stock-level-label']} element='label' textType={TextType.Caption} value={messages.onHand} />
      <Text
        className={style['stock-level']}
        element='span'
        textType={TextType.Caption}
        value={quantity === undefined ? <MDash /> : <FormattedNumber value={quantity} />}
      />
    </div>
  );
};

TotalStockLevel.propTypes = {
  quantity: PropTypes.number,
};
